
import {Vue, Component, Watch} from 'vue-property-decorator';
import {BTable, BDropdown} from "bootstrap-vue";
import store from "@/services/store";
import { loadUserLevels } from "../budget/budgetVariantService";
import {CorrectRowClass} from "@/modules/budget/budget-correct/CorectHelper";
import ReportModal from './InputReportModal.vue';
import DatePicker from 'vue2-datepicker';
import UrlModal from './UrlModal.vue';
import CommentModal from './CommentModal.vue';
import ExcelExport from './ExcelExport.vue'
import axios from "axios";
import VueElementLoading from "vue-element-loading";
import * as XLSX from 'xlsx';

interface TableItem {
    id: number;
    report_number: string;
    project: string;
    report_date: string;
    object_place: string;
    customer_bin: string;
    customer: string;
    planner_bin: string;
    planner: string;
    finance_source: string;
    timelimit: number | null;
    status: string;
    comment: string;
    url: string;
    object_category: string; 
    input_report: string;
    contract_number: string;
    project_code: string;
    contract_amount: null;
    amount_plan: null;
}

@Component({
    components: {
        loading: VueElementLoading,
        UrlModal,
        CommentModal,
        ReportModal,
        ExcelExport,
        DatePicker
    },
})

export default class psd_form extends Vue {
    async mounted() {
        await this.getUserLevels();
        await this.load_psd();  
        await this.loadFilterOptions();
        await this.getObl();
        await this.getCodeList();
        // this.initializeFilters(); // Заполняем фильтры
    }

    $refs!: {
        urlModal: UrlModal;
        drop: BDropdown;
        reportModal: ReportModal;
        excelExport: ExcelExport;
        table: BTable;
    };

    filterProjectCode: { project_code: string } | null = null;
    filterObjectName: { project: string } | null = null;
    filterProjectTime: { timelimit: number } | null = null;
    filterObjectPlace: { object_place: string } | null = null;
    filterCustomerBIN: { customer: string } | null = null;
    filterPlanner: { planner: string } | null = null;
    filterFinanceSource: { value: string } | null = null;
    filterStatus: { value: string; text: string } | null = null;
    filterCategory: { value: string; text: string } | null = null;
    filterProjectType: { value: string; text: string } | null = null;
    filterStartDate: string | null = null;
    filterEndDate: string | null = null;
    dateFromForInput: Date | null = null; // Дата начала
    dateToForInput: Date | null = null; // Дата окончания

    fields = [
        {key: 'report_number', label: 'Номер заключения', sortable: true},
        {key: 'project', label: 'Наименование проекта', sortable: true},
        {key: 'report_date', label: 'Дата заключения', sortable: true},
        {key: 'object_place', label: 'Место расположения объекта', sortable: true},
        {key: 'customer', label: 'Заказчик', sortable: true},
        {key: 'planner', label: 'Проектировщик', sortable: true},
        {key: 'project_code', label: 'Код проекта', sortable: false},
        {key: 'timelimit', label: 'Срок', sortable: true},
        {key: 'status', label: 'Статус', sortable: false},
        {key: 'comment', label: 'Комментарии', sortable: false},
        {key: 'url', label: 'URL', sortable: false},
        {key: 'object_category', label: 'Категория объекта', sortable: false},
        {key: 'input_report', label: 'Акт ввода', sortable: false},
        {key: 'contract_number', label: '№ договора', sortable: true},
        {key: 'contract_amount', label: 'Сумма по договору', sortable: true},
        {key: 'amount_plan', label: 'Сумма по плану', sortable: true}
    ]

    filteredItems: TableItem[] = [];
    items: TableItem[] = []

    modalVisible: boolean = false

    setText(key: string): string {
        const translations: Record<string, string> = {
            filter: "Фильтр",
            filter_params: "Параметры фильтра",
            DateOf: "Дата заключения",
            period_from: "с",
            period_to: "по",
            apply: "ПРИМЕНИТЬ",
            reset: "СБРОСИТЬ",
            report_title: "Проектно-сметная документация"
        };
        return translations[key] || key;
    }

    async loadFilterOptions() {
        try {
            const params = new URLSearchParams();
            if (this.filterProjectCode) params.append("project_code", this.filterProjectCode.project_code);
            if (this.filterObjectName) params.append("project", this.filterObjectName.project);
            if (this.filterProjectTime) params.append("timelimit", this.filterProjectTime.timelimit.toString());
            if (this.filterObjectPlace) params.append("object_place", this.filterObjectPlace.object_place);
            if (this.filterCustomerBIN) params.append("customer", this.filterCustomerBIN.customer);
            if (this.filterPlanner) params.append("planner", this.filterPlanner.planner);
            if (this.filterCategory) params.append("object_category", this.filterCategory.value);
            if (this.filterStatus) params.append("status", this.filterStatus.value);
            if (this.filterProjectType) {
                const hasUrl = this.filterProjectType.value === 'linked' ? 'true' : 'false';
                params.append("has_url", hasUrl);
            }
            if (this.dateFromForInput) {
                params.append("date_from", this.dateFromForInput.toISOString().slice(0, 10));
            }
            if (this.dateToForInput) {
                params.append("date_to", this.dateToForInput.toISOString().slice(0, 10));
            }

            const response = await fetch(`/api-py/psd/filters?${params.toString()}`);
            if (!response.ok) throw new Error("Ошибка запроса фильтров");
            const data = await response.json();

            this.filterProjectCodeOptions = (data.project_codes as string[]).map((code: string) => ({project_code: code}));
            this.filterObjectOptions = (data.projects as string[]).map((p: string) => ({ project: p }));
            this.filterProjectTimeOptions = (data.timelimits as number[]).map((t: number) => ({ timelimit: t }));
            this.filterObjectPlaceOptions = (data.object_places as string[]).map((o: string) => ({ object_place: o }));
            this.filterCustomerOptions = (data.customers as string[]).map((c: string) => ({ customer: c }));
            this.filterPlannerOptions = (data.planners as string[]).map((p: string) => ({ planner: p }));
            this.filterCategoryOptions = (data.categories as string[]).map((c: string) => ({ value: c, text: c }));
            this.categoryOptions = (data.categories as string[]).map((c: string) => ({ value: c, text: c })); 
            this.filterStatusOptions = this.formatToValueText(data.statuses as string[]);
            this.filterProjectTypeOptions = (data.project_types as string[]).map((val: string) => ({
                value: val,
                text: val === 'linked' ? 'Привязанные' : 'Без привязки'
            }));
            this.projectTypeCounts = data.project_type_counts || { linked: 0, unlinked: 0, all: 0 };

            const validateSelection = (
                current: Record<string, any> | null,
                list: Record<string, any>[],
                key: string
            ): boolean => {
                return !!current && list.some((opt: Record<string, any>) => opt[key] === current[key]);
            };

            if (!validateSelection(this.filterObjectName, this.filterObjectOptions, 'project')) {
                this.filterObjectName = null;
            }
            if (!validateSelection(this.filterProjectTime, this.filterProjectTimeOptions, 'timelimit')) {
                this.filterProjectTime = null;
            }
            if (!validateSelection(this.filterObjectPlace, this.filterObjectPlaceOptions, 'object_place')) {
                this.filterObjectPlace = null;
            }
            if (!validateSelection(this.filterCustomerBIN, this.filterCustomerOptions, 'customer')) {
                this.filterCustomerBIN = null;
            }
            if (!validateSelection(this.filterPlanner, this.filterPlannerOptions, 'planner')) {
                this.filterPlanner = null;
            }
            if (!validateSelection(this.filterCategory, this.filterCategoryOptions, 'value')) {
                this.filterCategory = null;
            }
            if (!validateSelection(this.filterStatus, this.filterStatusOptions, 'value')) {
                this.filterStatus = null;
            }
            if (!validateSelection(this.filterProjectType, this.filterProjectTypeOptions, 'value')) {
                this.filterProjectType = null;
            }
        } catch (e) {
            this.makeToast("danger", "Ошибка загрузки фильтров", String(e));
        }
    }


    applyFilter() {
        this.loading = true;
        this.page = 1;
        this.load_psd().then(() => this.loadFilterOptions());
    }

    async resetFilter() {
        this.filterProjectCode = null;
        this.filterObjectName = null;
        this.filterProjectTime = null;
        this.filterObjectPlace = null;
        this.filterCustomerBIN = null;
        this.filterPlanner = null;
        this.filterFinanceSource = null;
        this.filterCategory = null;
        this.filterStatus = null;
        this.filterProjectType = null;
        this.dateFromForInput = null;
        this.dateToForInput = null;
        this.page = 1;

        await this.load_psd();
        await this.loadFilterOptions(); 
    }

    private cachedFilters: Record<string, any[]> = {};

    getUniqueValues(array: any[], key: string): any[] {
        // ключ для кэша должен включать длину массива, чтобы обновлялось при изменении данных
        const cacheKey = `${key}_${array.length}`;
        if (this.cachedFilters[cacheKey]) return this.cachedFilters[cacheKey];

        const options = key === 'timelimit' ? [{ [key]: null, label: 'Null' }, ...array] : [...array];

        const result = Array.from(new Map(options.map(item => [item[key], item])).values())
            .sort((a, b) => {
                if (a[key] === null) return -1;
                if (b[key] === null) return 1;

                const aVal = typeof a[key] === 'number' ? a[key] : parseFloat(a[key]);
                const bVal = typeof b[key] === 'number' ? b[key] : parseFloat(b[key]);

                if (!isNaN(aVal) && !isNaN(bVal)) {
                    return aVal - bVal;
                }

                return String(a[key]).localeCompare(String(b[key]));
            });

        this.cachedFilters[cacheKey] = result;
        return result;
    }

    private hide() {
        (this.$refs.drop as BDropdown).hide(true)
    }

    page: number = 1;
    limit: number = 10;
    total: number = 0;

    async load_psd() {
        this.loading = true;
        try {
            const params = new URLSearchParams();

            if (this.sortBy) {
                params.append("sort_by", this.sortBy);
                params.append("sort_desc", this.sortDesc ? "true" : "false");
            }

            params.append("page", this.page.toString());
            params.append("limit", this.limit.toString());

            if (this.filterProjectCode) params.append("project_code", this.filterProjectCode.project_code);
            if (this.filterObjectName) params.append("project", this.filterObjectName.project);
            if (this.filterProjectTime) params.append("timelimit", this.filterProjectTime.timelimit.toString());  // Добавлено
            if (this.filterObjectPlace) params.append("object_place", this.filterObjectPlace.object_place);
            if (this.filterCustomerBIN) params.append("customer", this.filterCustomerBIN.customer);
            if (this.filterPlanner) params.append("planner", this.filterPlanner.planner);
            if (this.filterCategory) params.append("object_category", this.filterCategory.value);
            if (this.filterStatus) params.append("status", this.filterStatus.value);
            if (this.filterProjectType) {
                const hasUrl = this.filterProjectType.value === 'linked' ? 'true' : 'false';
                params.append("has_url", hasUrl);
            }
            if (this.dateFromForInput) {
                const fromDate = this.dateFromForInput.toISOString().slice(0, 10);
                params.append("date_from", fromDate);
            }
            if (this.dateToForInput) {
                const toDate = this.dateToForInput.toISOString().slice(0, 10);
                params.append("date_to", toDate);
            }

            const response = await fetch(`/api-py/psd/all?${params.toString()}`);
            if (!response.ok) throw new Error("Ошибка запроса");

            const result = await response.json();
            this.items = result.items;
            this.filteredItems = [...this.items]; 
            this.total = result.total;
        } catch (e) {
            this.makeToast("danger", "Ошибка загрузки данных", String(e));
        }
    }

    closeModal() {
        this.$emit('close');
    }

    exitWithoutSaving() {
        this.$emit('exit');
        this.closeModal();
    }

    saveAndExit() {
        this.$emit('save');
        this.closeModal();
    }

    selectedItem: any = null;

    onClickReport(item: any) {
        this.selectedItem = item; 
        console.log('selected', this.selectedItem);
        this.$bvModal.show("add_input_report_modal"); 
    }

    addReport(input_report: string) {
        if (this.selectedItem) {
            this.$set(this.selectedItem, "input_report", input_report);
            this.updateEditedItem(this.selectedItem);
        }
    }

    onClickUrl(item: any) {
        this.selectedItem = item;
        console.log('selected', this.selectedItem)
        this.$bvModal.show("add_url_modal")
    }

    addUrl(url: any) {
        this.$set(this.selectedItem, "url", url)
        this.updateEditedItem(this.selectedItem);
    }

    onClickComment(item: any) {
        this.selectedItem = item;
        console.log('selected', this.selectedItem)
        this.$bvModal.show("add_comment_modal")
    }

    addComment(comment: any) {
        this.$set(this.selectedItem, "comment", comment)
        this.updateEditedItem(this.selectedItem);
    }

    private makeToast(variant: any, title: string, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }

    truncateComment(comment: any) {
        return comment.length > 15 ? comment.slice(0, 15) + '...' : comment;
    }

    showModal = false;
    editedItem: TableItem = {} as TableItem;
    statusOptions = [
        {value: 'реализован', text: 'Реализован'},
        {value: 'активный', text: 'Активный'},
        {value: 'не реализован', text: 'Не реализован'},
        {value: 'требуется финансирование', text: 'Требуется финансирование'}
    ];

    categoryOptions: Array<{ value: string; text: string }> = [];
    filterProjectCodeOptions: { project_code: string }[] = [];

    financeOptions = [
        {value: 'государственный', text: 'Государственный'},
        {value: 'квазигосударственный', text: 'Квазигосударственный'},
        {value: 'частный', text: 'Частный'}
    ];

    filterProjectTypeOptions = [
        { value: 'linked', text: 'Привязанные' },
        { value: 'unlinked', text: 'Без привязки' }
    ];

    originalItems = [];

    async fetchData() {
        try {
            const response = await fetch('/api-py/psd/all');
            if (response.status === 200) {
                const result = await response.json();
                this.items = JSON.parse(JSON.stringify(result));
                this.originalItems = JSON.parse(JSON.stringify(result));
            }
        } catch (error) {
            console.error("Ошибка загрузки данных:", error);
        }
    }

    clickEditRow(item: TableItem) {
        console.debug(item)
    }

    editRow(item: TableItem) {
        this.editedItem = {...item}; // Создаём копию объекта, чтобы избежать привязки
        this.showModal = true;
    }

    editedItems: TableItem[] = []

    updateEditedItem(item: TableItem) {
        const index = this.editedItems.findIndex(i => i.report_number === item.report_number);
        if (index !== -1) {
            this.editedItems[index] = {...item};
        } else {
            this.editedItems.push({...item});
        }
    }

   async saveChanges() {
        let updated = 0;
        let failed = 0;

        for (const item of this.editedItems) {
            const result = await this.saveToDb(item);
            if (result === "updated") {
                updated++;
            } else if (result === "error") {
                failed++;
            }
        }

        this.editedItems = [];

        if (failed > 0) {
            this.makeToast("danger", "Ошибка", "Ошибка при сохранении");
        } else if (updated > 0) {
            this.makeToast("success", "Успех", "Успешно сохранено");
        } else {
            this.makeToast("info", "save-correct-data", "Изменений не было");
        }
    }

    async saveToDb(item: TableItem): Promise<"updated" | "nochange" | "error"> {
        try {
            const result = await fetch("/api-py/psd/update/", {
                method: 'PUT',
                body: JSON.stringify(item)
            });

            if (result.status === 200) {
                return "updated";
            } else {
                return "nochange";
            }
        } catch (error) {
            return "error";
        }
    }

    onlyNumbersFor(event: KeyboardEvent) {
        const allowedKeys = [
            'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', '.'
        ];

        const isDigit = /^\d$/.test(event.key);

        if (!isDigit && !allowedKeys.includes(event.key)) {
            event.preventDefault();
        }
    }

    handleAmountChange(item: any, field: 'contract_amount' | 'amount_plan') {
        const value = item[field];
        if (value === null || value === '' || isNaN(value)) {
            item[field] = null;
        } else {
            item[field] = parseFloat(parseFloat(value).toFixed(1));
        }
        this.updateEditedItem(item);
    }


    @Watch('dateFromForInput')
    onDateFromChange(newVal: Date | null) {
        if (newVal && this.dateToForInput && newVal > this.dateToForInput) {
            this.dateToForInput = newVal;
        }
    }

    @Watch('dateToForInput')
    onDateToChange(newVal: Date | null) {
        if (newVal && this.dateFromForInput && newVal < this.dateFromForInput) {
            this.dateFromForInput = newVal;
        }
    }

    getContractNumberProxy(item: TableItem): string {
        const onlyDigits = item.contract_number?.match(/\d+/g);
        return onlyDigits ? onlyDigits.join('') : item.contract_number || '';
    }

    onContractNumberInput(value: string, item: TableItem) {
        item.contract_number = value;
        this.updateEditedItem(item);
    }

    onlyNumbers(event: any) {

        if (!/^\d$/.test(event.key) && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
            event.preventDefault();
        }
    }

    onlyAllowedContractChars(event: KeyboardEvent) {
        const allowedPattern = /^[a-zA-Zа-яА-Я0-9\-\/]$/;
        if (!allowedPattern.test(event.key)) {
            event.preventDefault();
        }
    }

    sanitizeInput(row: any) {
        
        let value = row.item.timelimit.toString().replace(/\D/g, ''); 
        value = Math.min(Math.max(parseInt(value, 10) || 1, 1), 999); 
        row.item.timelimit = value;
    }

    noMoreThree(value: any) {
        return String(value).substring(0, 3);
    }

    async downloadPsdExcel() {
        try {
            const params = new URLSearchParams();

            if (this.filterProjectCode) params.append("project_code", this.filterProjectCode.project_code);
            if (this.filterObjectName) params.append("project", this.filterObjectName.project);
            if (this.filterProjectTime) params.append("timelimit", this.filterProjectTime.timelimit.toString());  // Добавлено
            if (this.filterObjectPlace) params.append("object_place", this.filterObjectPlace.object_place);
            if (this.filterCustomerBIN) params.append("customer", this.filterCustomerBIN.customer);
            if (this.filterPlanner) params.append("planner", this.filterPlanner.planner);
            if (this.filterCategory) params.append("object_category", this.filterCategory.value);
            if (this.filterStatus) params.append("status", this.filterStatus.value);
            if (this.filterProjectType) {
                const hasUrl = this.filterProjectType.value === 'linked' ? 'true' : 'false';
                params.append("has_url", hasUrl);
            }
            if (this.dateFromForInput) {
                const fromDate = this.dateFromForInput.toISOString().slice(0, 10);
                params.append("date_from", fromDate);
            }
            if (this.dateToForInput) {
                const toDate = this.dateToForInput.toISOString().slice(0, 10);
                params.append("date_to", toDate);
            }

            // Добавляем сортировку
            const sortBy = this.$refs.table?.localSortBy || null;
            const sortDesc = this.$refs.table?.localSortDesc || false;

            if (sortBy) {
                params.append("sort_by", sortBy);
                params.append("sort_desc", sortDesc ? "true" : "false");
            }

            const response = await fetch(`/api-py/psd/download?${params.toString()}`);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            let fromYearFormatted = 'все_года';
            let toYearFormatted = '';

            if (this.dateFromForInput) {
                fromYearFormatted = this.dateFromForInput.getFullYear().toString();
            }
            if (this.dateToForInput) {
                toYearFormatted = this.dateToForInput.getFullYear().toString();
            }

            const filename = `Проектно_сметная_документация_${fromYearFormatted}_${toYearFormatted}.xls`;

            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Ошибка при загрузке Excel-файла:", error);
            this.makeToast("danger", "Ошибка загрузки Excel", String(error));
        }
    }


    private loading: boolean = false;

        async downloadInfo() {
        try {
            this.makeToast("info", "Скачивание", "Скоро начнется скачивание...");

            const response = await axios({
                method: "post",
                url: "/api-py/get-info/39",
                responseType: "blob",
            });

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;

            const fileName = "Инструкция_проектно_сметная_документация.pdf";
            link.setAttribute("download", fileName);

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            this.makeToast("success", "Готово", `Файл успешно скачан.`);
        } catch (error) {
            console.error("Ошибка скачивания:", error);
            this.makeToast("danger", "Ошибка", "Не удалось скачать файл.");
        }
    }

    filterObjectOptions: any[] = [];
    filterProjectTimeOptions: any[] = [];
    filterObjectPlaceOptions: any[] = [];
    filterCustomerOptions: any[] = [];
    filterPlannerOptions: any[] = [];
    filterCategoryOptions: any[] = [];
    filterStatusOptions: any[] = [];

    initializeFilters() {
        this.filterObjectOptions = this.getUniqueValues(this.items, 'project');
        this.filterProjectTimeOptions = this.getUniqueValues(this.items, 'timelimit');
        this.filterObjectPlaceOptions = this.getUniqueValues(this.items, 'object_place');
        this.filterCustomerOptions = this.getUniqueValues(this.items, 'customer');
        this.filterPlannerOptions = this.getUniqueValues(this.items, 'planner');

        // Динамически сформированные поля в формате { value, text }
        const rawCategories = this.items.map(item => item.object_category).filter(Boolean);
        const rawStatuses = this.items.map(item => item.status).filter(Boolean);

        this.filterCategoryOptions = this.formatToValueText([...new Set(rawCategories)]);
        this.filterStatusOptions = this.formatToValueText([...new Set(rawStatuses)]);

        // Тип проекта (реактивно)
        const hasLinked = this.items.some(item => !!item.url);
        const hasUnlinked = this.items.some(item => !item.url);

        const projectTypeSet: Set<string> = new Set();
        if (hasLinked) projectTypeSet.add('linked');
        if (hasUnlinked) projectTypeSet.add('unlinked');

        if (this.filterProjectType && this.filterProjectType.value && !projectTypeSet.has(this.filterProjectType.value)) {
            this.filterProjectType = null;
        }

        this.filterProjectTypeOptions = [...projectTypeSet].map(val => ({
            value: val,
            text: val === 'linked' ? 'Привязанные' : 'Без привязки'
        }));
    }

    formatToValueText(array: string[]): { value: string, text: string }[] {
        return array.map(val => ({
            value: val,
            text: val.charAt(0).toUpperCase() + val.slice(1)  
        }));
    }

    @Watch('filterProjectCode')
    @Watch('filterObjectName')
    @Watch('filterProjectTime')
    @Watch('filterObjectPlace')
    @Watch('filterCustomerBIN')
    @Watch('filterPlanner')
    @Watch('filterCategory')
    @Watch('filterStatus')
    @Watch('filterProjectType')
    onFilterChange() {
         this.loadFilterOptions()
    }

    updateFilters() {
        const filteredItems = this.items.filter(item =>
            (!this.filterObjectName || item.project === this.filterObjectName.project) &&
            (!this.filterProjectTime || item.timelimit === this.filterProjectTime.timelimit) &&
            (!this.filterObjectPlace || item.object_place === this.filterObjectPlace.object_place) &&
            (!this.filterCustomerBIN || item.customer === this.filterCustomerBIN.customer) &&
            (!this.filterPlanner || item.planner === this.filterPlanner.planner) &&
            (!this.filterCategory || item.object_category === this.filterCategory.value) &&
            (!this.filterStatus || item.status === this.filterStatus.value) &&
            (!this.filterProjectType || (this.filterProjectType.value === 'linked' ? !!item.url : !item.url)) &&
            (!this.dateFromForInput || (item.report_date && new Date(item.report_date) >= this.dateFromForInput)) &&
            (!this.dateToForInput || (item.report_date && new Date(item.report_date) <= this.dateToForInput))
        );

        this.filteredItems = filteredItems;
        this.loadFilterOptions();
    }

    obl: string = '';

    async getObl() {
     await fetch('/api-py/get-budget-obl/' + store.state._instanceCode)
                        .then(response => response.json())
                        .then(json => {
                            if (json.obl) this.obl = json.obl;
                        });
        console.log('code',  store.state._instanceCode)
        console.log('obl', this.obl)
    }

    codeList: { value: string; text: string }[] = [];

    async getCodeList() {
        try {

            const types = ['imported,development', 'current,other'];

            const allRequests = await Promise.all(
                types.map(type =>
                    fetch(`/api-py/get-project-bank-code-list/${type}/${this.obl}/${this.userUiid}`)
                )
            );

            const allData = await Promise.all(allRequests.map(res => res.json()));
            console.log('projects', allData)

            const combined = allData.flat().map((item: { code: string }) => ({
                value: item.code,
                text: item.code
            }));

            this.codeList = combined;
        } catch (error) {
            this.makeToast("danger", "Ошибка загрузки кодов проектов", error instanceof Error ? error.message : String(error));
        }
    }

    async refreshFromGoogleSheets() {
            this.loading = true;
            this.makeToast("info", "Обновление началось", "Пожалуйста, подождите...");
            try {
                const response = await fetch('/api-py/psd/testload');

                let errorText = '';
                let successHandled = false;

                if (response.ok) {
                    const result = await response.json();
                    this.makeToast("success", "Данные обновлены", `Загрузка прошла успешно`);
                    await this.load_psd();
                    successHandled = true;
                } else {
                    try {
        const errorData = await response.json();

        if (Array.isArray(errorData)) {
            errorText = errorData.map((err: any) => {
                const row = err?.row ?? '?';
                const field = err?.field ?? 'неизвестно';
                const value = err?.value ?? 'не указано';
                const msg = err?.error ?? 'неизвестная ошибка';

                return `Ошибка в строке ${row}: поле "${field}" → "${value}". ${msg}`;
            }).join('\n');
        } else if (errorData.detail) {
            // Может быть либо строка, либо массив
            if (Array.isArray(errorData.detail)) {
                errorText = errorData.detail.map((err: any) => {
                    const row = err?.row ?? '?';
                    const field = err?.field ?? 'неизвестно';
                    const value = err?.value ?? 'не указано';
                    const msg = err?.error ?? 'неизвестная ошибка';

                    return `Ошибка в строке ${row}: поле "${field}" → "${value}". ${msg}`;
                }).join('\n');
            } else {
                errorText = errorData.detail;
            }
        } else {
            errorText = JSON.stringify(errorData);
        }
        } catch (jsonError) {
            errorText = await response.text();  // fallback
    }


                console.error("Ошибка загрузки:", response.status, errorText);
                this.makeToast("danger", `Ошибка загрузки (${response.status})`, errorText);
            }
        } catch (error) {
            this.makeToast("danger", "Ошибка обновления данных", error instanceof Error ? error.message : String(error));
        } finally {
            this.loading = false;
        }
    }


    get userUiid() {
        return store.state.user.sub;
    }

    accessLevel: number = 0

    async getUserLevels() {
        if (this.userUiid) {
            let response: any = [];
            try {
                await loadUserLevels(this.userUiid).then(data => {
                    response = data;
                });
                for (const row of response) {
                    switch (row.modules) {
                        case "003.006":
                            this.accessLevel = row.access_level;
                            break;
                            default:
                                break;
                    }
                }
            } catch (error) {
                this.makeToast("danger", "Ошибка getUserLevels", error instanceof Error ? error.message : String(error));
            }
        }
    }

    get isItemDisabled() {
        const levelAccessToEdit = [2, 3];
        return !levelAccessToEdit.includes(this.accessLevel);
    }

    
    availableForUser = true;

    async created() {
        await this.getUserLevels();
        if (![1, 2, 3].includes(this.accessLevel)) {
            this.availableForUser = false
            this.makeToast('danger', 'Отсутствует доступ к режиму', 'Сообщение')
            return
        }
    }

    pageSizeOptions = [10, 20, 50];

    onChangeLimit(newLimit: number) {
        this.limit = newLimit;
        this.page = 1;
        this.load_psd();
    }

    onSortChange(ctx: { sortBy: string; sortDesc: boolean }) {
        this.sortBy = ctx.sortBy;
        this.sortDesc = ctx.sortDesc;
        this.page = 1; 
        this.load_psd();
    }


    sortBy: string = 'report_number'
    sortDesc: boolean = false

    projectTypeCounts: { linked: number; unlinked: number; all: number } = {
        linked: 0,
        unlinked: 0,
        all: 0
    };  

    selectProjectType(type: string | null) {
        if (type === null) {
            this.filterProjectType = null; 
        } else {
            this.filterProjectType = this.filterProjectTypeOptions.find(opt => opt.value === type) || null;
        }

        this.page = 1;
        this.load_psd();
        this.loadFilterOptions();

        // Открываем выпадающее меню фильтров
        const drop = this.$refs.drop as any;
        if (drop?.show) drop.show(true);
    }
 


}

